import React from 'react';

const SharedComponents = () => {
  return (
    <Gallery>
      <GalleryItem
        title="Button"
        description="A simple button component"
        image="https://example.com/button.png"
        link="https://example.com/button"
      />
      <GalleryItem
        title="Input"
        description="A simple input component"
        image={"../assets/img/2.png"}
        link="https://example.com/input"
      />
      <GalleryItem
        title="Dropdown"
        description="A simple dropdown component"
        image="https://example.com/dropdown.png"
        link="https://example.com/dropdown"
      />
    </Gallery>
  );
};

export default SharedComponents;

// Gallery.js

const Gallery = ({ children }) => {
  return (
    <div className="gallery">
      {children}
    </div>
  );
};
const GalleryItem = ({ title, description, image, link }) => {
    return (
      <div className="gallery-item container">
        <h3>{title}</h3>
        <p className='no-over'>{description}</p>
        <img src={image} alt={title} />
        <a href={link}>View Component</a>
      </div>
    );
  };
export { Gallery, GalleryItem };

// GalleryItem.js


